import { SearchOutlined } from "@ant-design/icons";
import { Col, DatePicker, Empty, Input, Row, Spin, Switch } from "antd";
import CustomImage from "app/components/CustomImage/CustomImage";
import LayoutTableV2 from "app/components/TableV2";
import clsx from "clsx";
import { useHandleSubmitApi } from "hook";
import { IGetMediaForPaginateInputModel, IMediaOutputModel } from "interfaces/media";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { MediaServices } from "services/media";
import MediaInformationContent from "../../MediaInformationContent/MediaInformationContent";

export interface IMediaUploadTableProps {
  medias?: IMediaOutputModel[];
  isMultipleSelect?: boolean;
  onChooseItem?: (item: IMediaOutputModel[]) => void;
  onUpdateOrCreateCompleted?: () => void;
}

export default function MediaUploadTable(props: IMediaUploadTableProps) {
  const { RangePicker } = DatePicker;
  const [list, setList] = useState<IMediaOutputModel[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(30);
  const [dates, setDates] = useState([]);
  const [media, setMedia] = useState<IMediaOutputModel[]>([]);
  const [isCheckedMulti, setIsCheckedMulti] = useState(props?.isMultipleSelect);

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line
  }, [dates, searchValue, pageNum, pageSize]);

  const handleFilter = () => {
    const filter: IGetMediaForPaginateInputModel = {
      pageSize: pageSize,
      pageNum: pageNum,
      searchValue: searchValue,
    };
    if (!!dates?.length) {
      filter["fromDate"] = dates[0];
      filter["toDate"] = dates[1];
    }
    getListMediaService(filter);
  };

  const [getListMediaService, loading] = useHandleSubmitApi(async (filter: IGetMediaForPaginateInputModel) => {
    const dataRes = await MediaServices.getMedia(filter);
    if (dataRes) {
      setTotalRecord(dataRes?.meta?.totalRecords);
      setList(dataRes?.data || []);
    }
  });

  const renderHeader = () => {
    return (
      <React.Fragment>
        <div className="layout-list__header__menu" style={{ width: "20rem" }}>
          <h4>Đã chọn: {props.medias?.length}</h4>
        </div>
        <div className="d-flex items-center justify-center">
          <RangePicker
            className="mr_1"
            onChange={(values: any, dateStrings) => setDates(values?.map((d: any) => new Date(d).toISOString()))}
            style={{ width: 300 }}
            placeholder={["Ngày Bắt Đầu", "Ngày Kết Thúc"]}
          />
          <Input
            placeholder="Nhập thông tin tìm kiếm"
            className="mr_1"
            suffix={<SearchOutlined />}
            onChange={_.debounce((e) => {
              setPageSize(30);
              setPageNum(1);
              setSearchValue(e.target.value);
            }, 200)}
            style={{ width: 200 }}
            allowClear
          />
          <Switch disabled checked={isCheckedMulti} onChange={(e) => setIsCheckedMulti(e)}></Switch>{" "}
          <span className="ml_0-5">Chọn nhiều Media</span>
        </div>
      </React.Fragment>
    );
  };

  const renderContent = () => {
    return (
      <Spin spinning={loading}>
        <div className="w_100" style={{ height: "calc(100vh - 450px)" }}>
          <Row gutter={[12, 12]} className="media-list-body">
            {list?.length ? (
              [...list]?.map((l) => {
                const url = l.path;
                const isActive = media.some((m) => m.id === l.id);
                return (
                  <Col
                    key={l.id}
                    xxl={4}
                    xl={6}
                    lg={8}
                    md={12}
                    sm={12}
                    xs={24}
                    className={clsx({
                      "media-list-body__item": true,
                      "media-list-body__item-active": isActive,
                    })}
                  >
                    <CustomImage
                      src={url}
                      alt={l.title}
                      onClick={() => {
                        if (isCheckedMulti) {
                          return handleChooseItem(l);
                        }
                        setMedia([l]);
                        props.onChooseItem && props.onChooseItem([l]);
                      }}
                    />
                  </Col>
                );
              })
            ) : (
              <Col span={24}>
                <Empty />
              </Col>
            )}
          </Row>
        </div>
      </Spin>
    );
  };

  const handleChooseItem = (item: IMediaOutputModel) => {
    let results: IMediaOutputModel[] = [...(props.medias || [])];
    const find = props.medias?.find((m) => m?.id === item?.id);
    if (!find) {
      results.push(item);
    } else {
      results = results.filter((r) => r.id !== item.id);
    }
    setMedia(results);
    props.onChooseItem && props.onChooseItem(results);
  };

  return (
    <Row gutter={[20, 20]}>
      <Col span={isCheckedMulti ? 24 : 16} style={{ borderRight: "1px solid #dbdbdb" }}>
        <LayoutTableV2<IMediaOutputModel>
          header={() => <React.Fragment>{renderHeader()}</React.Fragment>}
          body={() => <React.Fragment>{renderContent()}</React.Fragment>}
          data={list.map((l) => ({ ...l, key: l.id }))}
          columns={[]}
          optionPaginate={{
            numberRecordShow: list.length,
            totalRecord: totalRecord,
            pageNum: pageNum,
            pageSize: pageSize,
            onChangePageNum: (number) => {
              setPageNum(number);
            },
            onShowSizeChange: (_, size) => setPageSize(size),
          }}
        />
      </Col>
      {!isCheckedMulti && (
        <Col span={8} style={{ height: "calc(100vh - 300px)", overflowY: "auto", overflowX: "hidden" }}>
          {!!media?.length ? (
            <MediaInformationContent data={media[0]} onUpdateOrCreateCompleted={() => handleFilter()} />
          ) : (
            <></>
          )}
        </Col>
      )}
    </Row>
  );
}
